import { useEffect } from "react";
import { useTranslation } from "react-i18next";

interface AssistantData {
  language?: string;
}

interface UseLanguageProps {
  assistantData?: AssistantData;
  enableBrowserDetection?: boolean;
}

export const useLanguage = ({
  assistantData,
  enableBrowserDetection = false,
}: UseLanguageProps) => {
  const { i18n } = useTranslation();

  useEffect(() => {
    if (enableBrowserDetection) {
      // En la página 404, usar detección del navegador
      i18n.changeLanguage();
    } else if (assistantData?.language) {
      // En otras páginas, usar el idioma del assistant
      const language = assistantData.language.toLowerCase();

      // Mapear idiomas soportados
      const supportedLanguages = ["es", "en"];
      const mappedLanguage = supportedLanguages.includes(language)
        ? language
        : "es"; // Fallback a español

      if (i18n.language !== mappedLanguage) {
        i18n.changeLanguage(mappedLanguage);
      }
    } else {
      // Si no hay idioma del asistente, usar español como fallback
      if (i18n.language !== "es") {
        i18n.changeLanguage("es");
      }
    }
  }, [assistantData?.language, enableBrowserDetection, i18n]);

  return {
    currentLanguage: i18n.language,
    changeLanguage: i18n.changeLanguage,
  };
};
